import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
function Type(props){
  const type = props.type
  const [selectedType] = useEnvValue('selectedType',null)

  return (
    <label htmlFor={"type-"+type.key}>
      <input type="radio" id={"type-"+type.key} name={'prima_type'} value={type.key} onChange={props.onChange} defaultChecked={selectedType === type.key}/>
      <span className={'type'}>
        {type.name}
      </span>
    </label>
  )
}

export default observer(Type)